var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass: "section-invert py-lg-5 py-0 reverse-sm",
      attrs: { id: "video-as-service" }
    },
    [
      _c("b-col", { staticClass: "p-0 p-lg-5", attrs: { md: "12", lg: "6" } }, [
        _c("div", { staticClass: "col-bg ml-lg-auto" })
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "content my-auto", attrs: { md: "12", lg: "6" } },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("openlegal.video-service")) + " ")]),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("openlegal.description")))]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("openlegal.how-to-request-video")) +
                  "\n        "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                "\n        1. " +
                  _vm._s(_vm.$t("openlegal.steps.1")) +
                  "\n        "
              ),
              _c("br"),
              _vm._v(
                "\n        2. " +
                  _vm._s(_vm.$t("openlegal.steps.2")) +
                  "\n        "
              ),
              _c("br"),
              _vm._v(
                "\n        3. " +
                  _vm._s(_vm.$t("openlegal.steps.3")) +
                  "\n        "
              ),
              _c("br"),
              _vm._v(
                "\n        4. " +
                  _vm._s(_vm.$t("openlegal.steps.4")) +
                  "\n         "
              ),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("small", [
                _vm._v(
                  "\n          *" +
                    _vm._s(_vm.$t("openlegal.how-to-request-answer-2")) +
                    "\n        "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "base-button",
            {
              staticClass: "mt-5",
              attrs: { white: "", outline: "" },
              on: {
                click: function($event) {
                  return _vm.$helpers.goToSection("contact-form")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("openlegal.more-info")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1efebf08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1efebf08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/openlegal/OpenlegalVideoService.vue
// module id = 4352
// module chunks = 40